// Compensi Studio + Commerciale (Tommaso De Angelis) + Segnalatore + Consulente Sabatini
// Le fasce sono le stesse di ResultsPanel.jsx: calcolate sul beneficio iperammortamento.

export const PRATICA_FASCE = [
  { key: "F1", max: 20000, label: "0-20k€", gse: 1200, perizia: 1200, revisore: 900, tommaso: 900 },
  { key: "F2", max: 50000, label: "20-50k€", gse: 1400, perizia: 1800, revisore: 1000, tommaso: 1050 },
  { key: "F3", max: 100000, label: "50-100k€", gse: 1700, perizia: 2700, revisore: 1800, tommaso: 1325 },
  { key: "F4", max: 200000, label: "100-200k€", gse: 1900, perizia: 4200, revisore: 2100, tommaso: 1600 },
  { key: "F4", max: Infinity, label: "200k€+", gse: 1900, perizia: 4200, revisore: 2100, tommaso: 1600 },
];

export const QUOTA_SEGNALATORE = 500;
export const CONSULENTE_SABATINI_NOME = "Alessandro Cappelletti";

const SABATINI_FISSA = 350;
const SABATINI_PCT = 0.07;

/**
 * Calcola tutti i compensi partendo dal calc_snapshot del dossier
 * e dallo stato del segnalatore.
 *
 * Ritorna null se non c'è calc_snapshot valido.
 *
 * Regole:
 * - Fasce basate su beneficio iperammortamento.
 * - Incasso Studio (lordo) = GSE + perizia + revisore (TUTTO tranne la parte Sabatini
 *   che va al consulente Cappelletti pass-through).
 * - Quota Tommaso (commerciale) = tabella per fascia, decurtata di 500€ se segnalatore attivo (di cui).
 * - Quota Segnalatore = 500€ se attivo (di cui).
 * - Quota Alessandro Cappelletti (consulente Sabatini) = 350€ fissi + 7% del beneficio Sabatini
 *   (pass-through, NON incasso studio). Solo se la pratica prevede Nuova Sabatini.
 */
export function computeCompensi(dossier) {
  const calc = dossier?.calc_snapshot;
  if (!calc) return null;

  const beneficio = calc.beneficio_iperammortamento || 0;
  const fascia = PRATICA_FASCE.find((f) => beneficio <= f.max) || PRATICA_FASCE[PRATICA_FASCE.length - 1];

  const quotaCappelletti =
    calc.sabatini_beneficio > 0 ? SABATINI_FISSA + calc.sabatini_beneficio * SABATINI_PCT : 0;

  // Studio incassa TUTTO tranne la parte Sabatini (che va al consulente Cappelletti).
  // Il revisore è ora parte del compenso studio (non più pass-through).
  const compensoRevisore = fascia.revisore;
  const incassoStudioLordo = fascia.gse + fascia.perizia + compensoRevisore;

  const segnalatoreAttivo = !!dossier?.segnalatore_attivo && !!dossier?.segnalatore_id;
  const quotaSegnalatore = segnalatoreAttivo ? QUOTA_SEGNALATORE : 0;
  const quotaTommaso = Math.max(0, fascia.tommaso - quotaSegnalatore);

  const incassoStudioNetto = incassoStudioLordo - quotaTommaso - quotaSegnalatore;

  return {
    fascia,
    beneficio,
    // Sabatini (pass-through)
    quotaCappelletti,
    sabatiniPratica: quotaCappelletti,
    // Studio (compenso revisore ora incluso)
    incassoStudioLordo,
    compensoRevisore,
    quotaTommaso,
    quotaSegnalatore,
    segnalatoreAttivo,
    incassoStudioNetto,
    totaleFatturabile: incassoStudioLordo + quotaCappelletti,
  };
}
